import React, { useRef, useState, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Paper,
    Link,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import './estilos.css'
import StepMenuHtmlCss from "./StepMenuHtmlCss";
import imagen1 from "../../assets/guias_implementacion/HtmlCss/1.png"
import GuiaHeader from "./GuiaHeader";

const GuiaHtmlCss = () => {
    const ignoreScroll = useRef(false);
    const scrollTimeoutRef = useRef(null);

    const introduccionRef = useRef(null);
    const implementacion = useRef(null);
    const parametros = useRef(null);
    const personalizacion = useRef(null);
    const recomendaciones = useRef(null);

    /* eslint-disable */
    const pasoRefs = [
        introduccionRef,
        implementacion,
        parametros,
        personalizacion,
        recomendaciones
    ];

    const [pasoActivo, setPasoActivo] = useState("Introducción");

    const nombresPasos = [
        "Introducción",
        "Implementación",
        "Parámetros",
        "Personalización",
        "Recomendaciones"
    ];

    const codeString = `<script>
  window.onload = function () {
    const bmvScript = document.createElement('script');
    bmvScript.src = 'https://widget.bemyvega.com/build/bmvPlugin.js';
    bmvScript.addEventListener('load', () => {
      const settings = {};
      BmvPlugin.setConfig(settings);
    });
    document.head.appendChild(bmvScript);
  };
</script>`;

    const codeString2 = `const settings = {
    color: "#7894CC",
    mode: "light",
    iconPosition: "bottomRight",
    autoDeploy: false,
    windowPosition: "right",
    iconType: "whiteRoundIcon",
    defaultLanguage: "es",
    iconSizeValue: "large"
};
`;

    const codeString3 = `<script>
    window.onload = function () {
        const bmvScript = document.createElement('script');
        bmvScript.src= 'https://widget.bemyvega.com/build/bmvPlugin.js';
        bmvScript.addEventListener('load', () => {
            const settings = {
                color: "#7894CC",
                mode: "light",
                iconPosition: "bottomRight",
                autoDeploy: false,
                windowPosition: "right",
                iconType: "whiteRoundIcon",
                defaultLanguage: "es",
                iconSizeValue: "large"
            };
            BmvPlugin.setConfig(settings);
        });
        document.head.appendChild(bmvScript);
    };
</script>
`;

    const copyToClipboard = () => {
        navigator.clipboard.writeText(codeString);
    };

     const copyToClipboard2 = () => {
        navigator.clipboard.writeText(codeString2);
    };

     const copyToClipboard3 = () => {
        navigator.clipboard.writeText(codeString3);
    };

    const handleScrollTo = (index) => {
        ignoreScroll.current = true;

        // Cancelar cualquier timeout anterior
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        // Iniciar nuevo scroll
        const targetRef = pasoRefs[index];
        targetRef.current?.scrollIntoView({ behavior: "smooth" });

        // Esperar antes de volver a activar el scroll listener
        scrollTimeoutRef.current = setTimeout(() => {
            ignoreScroll.current = false;
        }, 800); // Puedes ajustar este tiempo si lo ves necesario
    };


    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const handleScroll = () => {
            if (ignoreScroll.current) return;
            for (let i = pasoRefs.length - 1; i >= 0; i--) {
                const ref = pasoRefs[i].current;
                if (ref) {
                    const rect = ref.getBoundingClientRect();
                    if (rect.top <= 250) {
                        const nuevoPaso = nombresPasos[i];
                        setPasoActivo(nuevoPaso);
                        break;
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, []);

/*
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
*/


    return (
        <Box sx={{ display: "flex", flexDirection: "column", width: "100%", p: 4, pb: 0, mr: { xs: -1 }, pr: { xs: 0 } }}>
            <GuiaHeader plataforma="HTML" />

            <Box sx={{ display: "flex", marginTop: { xs: 10, md: 10 }, alignItems: "flex-start", ml: { xs: -6, md: 0 } }}>
                <Box sx={{ mt: -0.3, display: { xs: 'none', md: 'block' } }}>
                    <StepMenuHtmlCss handleScrollTo={handleScrollTo} pasoActivo={pasoActivo} setPasoActivo={setPasoActivo} />
                </Box>

                <Box sx={{ display: "flex", flexGrow: 1, paddingLeft: { xs: 0, md: 28 }, flexDirection: 'column' }}>
                    <Box sx={{ flexGrow: 1, paddingLeft: 4.26, position: "relative" }}>
                        {/* Barra vertical dentro del contenido */}
                        <Box
                            sx={{
                                position: "absolute",
                                width: "4px",
                                height: "100%",
                                backgroundColor: "rgb(162, 182, 212)",
                                left: 0,
                                top: 10,
                                display: { xs: 'none', md: 'block' }
                            }}
                        />
                        {/* Introducción */}
                        <Box sx={{ position: "relative", paddingLeft: 0 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={introduccionRef} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Introducción
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    Lo primero de todo, bienvenido a la familia de BeMyVega y gracias por elegirnos para hacer accesible tu página web.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 2 }}>
                                    Tras haber contratado el Widget de Accesibilidad de BeMyVega te habrá llegado un correo electrónico en el que se te ha proporcionado el fragmento de código que debes implementar
                                    en las páginas web del dominio dado de alta para integrar nuestro widget, aun así, a continuación se te indicara como integrarlo.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: 6.5 }}>
                                    De la misma manera, en esta guía encontrarás todas las opciones de personalización que tienes a tu disposición en nuestro widget, las cuales te permitirán adaptarlo a tu sitio web.
                                </Typography>
                            </Box>
                        </Box>

                        {/* Implementación */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={implementacion} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Implementación
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1 }}>
                                    Para implementar el Widget de Accesibilidad de BeMyVega en tu página web solo es necesario incluir el sencillísimo fragmento de código que encontrarás a continuación en el archivo o archivos .html de tu página web, dicho fragmento es el siguiente:
                                </Typography>
                                <Paper
                                    sx={{
                                        padding: 2,
                                        marginTop: 2,
                                        position: "relative",
                                        boxShadow: "0px 0px 24px 2px rgba(0, 0, 0, 0.2)",
                                        overflowX: "auto",
                                        maxWidth: "100%",
                                        whiteSpace: "pre-wrap", // opcional para mantener saltos de línea
                                        wordBreak: "break-word", // rompe palabras largas
                                    }}
                                >

                                    <Typography component="pre" sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                                        {codeString}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{ position: "absolute", top: { xs: 4, md: 8 }, right: { xs: 4, md: 8 } }}
                                        onClick={copyToClipboard}
                                        startIcon={<ContentCopyIcon />}
                                    >
                                        Copiar
                                    </Button>
                                </Paper>
                                <Typography variant="body1" sx={{ marginTop: 4, mb: 2 }}>
                                    Tal y como se ha comentado, este es el código de implementación por defecto, por lo que el posicionamiento y apariencia que se verán son los predeterminados.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 2, mb: 2 }}>
                                    En caso de querer customizar el posicionamiento del widget, la apariencia o ambos, diríjase al apartado 3. Parámetros.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 2, mb: 2 }}>
                                    Este fragmento de código debe incluirse lo más al principio posible del &lt;head&gt;&lt;/head&gt;
                                    del archivo o archivos .html de tu página web.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 2, mb: 2 }}>
                                    En caso de que tu sitio Web esté compuesto por varios archivos HTML, es necesario implementar este código en cada uno de dichos archivos en el lugar correspondiente que se ha especificado.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 2, mb: 2 }}>
                                    Una vez añadido el fragmento, el Widget de accesibilidad ya estará implementado en tu sitio web y brindando a tus usuarios multitud de funcionalidades.
                                </Typography>
                            </Box>
                        </Box>


                        {/* Parámetros */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={parametros} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Parámetros
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1 }}>
                                    En el fragmento de código que se te ha proporcionado podrás ver la siguiente función, pero con todos los parámetros y sus valores ya rellenos en este caso:
                                </Typography>
                                <Paper
                                    sx={{
                                        padding: 2,
                                        marginTop: 2,
                                        position: "relative",
                                        boxShadow: "0px 0px 24px 2px rgba(0, 0, 0, 0.2)",
                                        overflowX: "auto",
                                        maxWidth: "100%",
                                        whiteSpace: "pre-wrap", // opcional para mantener saltos de línea
                                        wordBreak: "break-word", // rompe palabras largas
                                    }}
                                >

                                    <Typography component="pre" sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                                        {codeString2}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{ position: "absolute", top: { xs: 4, md: 8 }, right: { xs: 4, md: 8 } }}
                                        onClick={copyToClipboard2}
                                        startIcon={<ContentCopyIcon />}
                                    >
                                        Copiar
                                    </Button>
                                </Paper>
                                <Typography variant="body1" sx={{ marginTop: 4 }}>
                                    Quedando el script de implementación de la siguiente forma:
                                </Typography>
                                <Paper
                                    sx={{
                                        padding: 2,
                                        marginTop: 2,
                                        position: "relative",
                                        boxShadow: "0px 0px 24px 2px rgba(0, 0, 0, 0.2)",
                                        overflowX: "auto",
                                        maxWidth: "100%",
                                        whiteSpace: "pre-wrap", // opcional para mantener saltos de línea
                                        wordBreak: "break-word", // rompe palabras largas
                                    }}
                                >

                                    <Typography component="pre" sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}>
                                        {codeString3}
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{ position: "absolute", top: { xs: 4, md: 8 }, right: { xs: 4, md: 8 } }}
                                        onClick={copyToClipboard3}
                                        startIcon={<ContentCopyIcon />}
                                    >
                                        Copiar
                                    </Button>
                                </Paper>
                                <Typography variant="body1" sx={{ marginTop: 4 }}>
                                    Como se ve, el widget puede recibir varios parámetros de entrada, te explicamos lo que significan y para qué se usan:
                                </Typography>
                                <Box mt={-3} sx={{ fontSize: '16px' }}>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <th>Parámetro de personalización</th>
                                            <th>Descripción</th>
                                        </tr>
                                        <tr>
                                            <td>color</td>
                                            <td>Color corporativo que se aplicará en el menú de navegación del Widget.</td>
                                        </tr>
                                        <tr>
                                            <td>mode</td>
                                            <td>Tema visual de los colores que se aplicará al widget, los usuarios pueden luego modificarlo desde la propia interfaz del widget.</td>
                                        </tr>
                                        <tr>
                                            <td>iconPosition</td>
                                            <td>Determinará el lugar de tu página Web en donde aparecerá el botón del Widget, el cual tras pulsarlo, abrirá el menú con todas nuestras funcionalidades.</td>
                                        </tr>
                                        <tr>
                                            <td>autoDeploy</td>
                                            <td>Indica si el widget se desplegará automáticamente tras cargarse toda tu página o se mostrará el botón de primeras.</td>
                                        </tr>
                                        <tr>
                                            <td>windowPosition</td>
                                            <td>Indica la posición en la que aparecerá la ventana del widget con sus respectivas funcionalidades.</td>
                                        </tr>
                                        <tr>
                                            <td>iconType</td>
                                            <td>Indica el icono del botón que se mostrará en tu sitio web.</td>
                                        </tr>
                                        <tr>
                                            <td>iconSizeValue</td>
                                            <td>Indica el tamaño del Widget.</td>
                                        </tr>
                                        <tr>
                                            <td>defaultLanguage</td>
                                            <td>Indica el idioma del Widget.</td>
                                        </tr>
                                    </table>
                                </Box>
                                <Typography variant="body1">
                                    Todos estos parámetros son opcionales, por lo que si no se envían se usarán los definidos por defecto.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 2 }}>
                                    Adicionalmente, dichos parámetros se definen como parámetros de personalización.
                                </Typography>
                            </Box>
                        </Box>


                        {/* Personalización */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: 6.5 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={personalizacion} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Personalización
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1 }}>
                                    En este apartado vamos a comentar los distintos valores permitidos para los parámetros de personalización y que te van a permitir personalizar según tus gustos y necesidad el widget.
                                </Typography>
                                <Box mt={-3} sx={{ fontSize: { xs: "13px", md: '16px' } }}>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <th>Parameter</th>
                                            <th>Default_value</th>
                                            <th>Values</th>
                                        </tr>
                                        <tr>
                                            <td>color</td>
                                            <td>blue</td>
                                            <td>nombre del color deseado en inglés o en formato hexadecimal</td>
                                        </tr>
                                        <tr>
                                            <td>mode</td>
                                            <td>light</td>
                                            <td>light | dark</td>
                                        </tr>
                                        <tr>
                                            <td>iconPosition</td>
                                            <td>bottomRight</td>
                                            <td>bottomRight | bottomCenter | bottomLeft | middleRight | middleLeft | topRight | topCenter | topLeft</td>
                                        </tr>
                                        <tr>
                                            <td>autoDeploy</td>
                                            <td>false</td>
                                            <td>false | true</td>
                                        </tr>
                                        <tr>
                                            <td>windowPosition</td>
                                            <td>right</td>
                                            <td>right | left</td>
                                        </tr>
                                        <tr>
                                            <td>iconType</td>
                                            <td>whiteRoundIcon</td>
                                            <td>whiteRoundIcon | whiteSquareIcon | whiteThinIcon | blackRoundIcon | blackSquareIcon | blackThinIcon</td>
                                        </tr>
                                        <tr>
                                            <td>iconSizeValue</td>
                                            <td>large</td>
                                            <td>small | large | extraLarge</td>
                                        </tr>
                                        <tr>
                                            <td>defaultLanguage</td>
                                            <td>es</td>
                                            <td>es | en | bg | fr | de | ca | eu | gl</td>
                                        </tr>
                                    </table>
                                </Box>
                                <Typography variant="body1">
                                    Para el correcto funcionamiento del widget es indispensable que se respete el formato de los valores y no se modifiquen, en caso contrario el widget usará los valores por defecto.
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 3 }}>
                                    A continuación el idioma asociado a los valores del parámetro de personalización defaultLanguage:
                                </Typography>
                                <Box sx={{ mt: -3, fontSize: '16px' }}>
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <th>Valor</th>
                                            <th>Idioma</th>
                                        </tr>
                                        <tr>
                                            <td>es</td>
                                            <td>español</td>
                                        </tr>
                                        <tr>
                                            <td>en</td>
                                            <td>inglés</td>
                                        </tr>
                                        <tr>
                                            <td>bg</td>
                                            <td>búlgaro</td>
                                        </tr>
                                        <tr>
                                            <td>fr</td>
                                            <td>francés</td>
                                        </tr>
                                        <tr>
                                            <td>de</td>
                                            <td>alemán</td>
                                        </tr>
                                        <tr>
                                            <td>ca</td>
                                            <td>catalán</td>
                                        </tr>
                                        <tr>
                                            <td>eu</td>
                                            <td>euskera</td>
                                        </tr>
                                        <tr>
                                            <td>gl</td>
                                            <td>gallego</td>
                                        </tr>
                                    </table>
                                </Box>
                                <Typography variant="body1">
                                    A continuación, presentamos los aspectos de los distintos iconos elegibles:
                                </Typography>
                                <Box
                                    component="img"
                                    src={imagen1}
                                    alt="Imagen"
                                    sx={{
                                        width: { xs: "100%", md: "500px" },
                                        mt: 1
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Recomendaciones */}
                        <Box sx={{ position: "relative", paddingLeft: 0, mb: -4 }}>
                            {/* Punto azul */}
                            <Box
                                sx={{
                                    width: "17px",
                                    height: "33px", // más alto que ancho
                                    backgroundColor: "#0F52BD",
                                    borderRadius: "10px", // borde redondeado pero no circular
                                    position: "absolute",
                                    left: "-40.6px",
                                    top: '0px',
                                    display: { xs: 'none', md: 'block' }
                                }}
                            />
                            <Box ml={{ xs: -2, md: 0 }}>
                                <Typography tabIndex="0" ref={recomendaciones} variant="h5" sx={{ color: "#0F52BD", fontWeight: "medium", scrollMarginTop: "120px" }}>
                                    Recomendaciones
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: 1, mb: { xs: 3, md: 2 } }}>
                                    Aunque la presentación visual del widget queda totalmente a vuestra decisión, recomendamos seguir los siguientes criterios a la hora de personalizarlo:
                                </Typography>
                                <Box sx={{ fontSize: '16px', ml: { xs: 0, md: 3 } }}>
                                    <ul style={{ paddingLeft: 2, listStylePosition: 'inside' }}>
                                        <li><strong>color</strong>
                                            <ul>
                                                <li>Usad el color corporativo de tu web, de esta forma conseguimos una armonía entre el widget y la elección de colores de su web a nivel visual.</li>
                                            </ul>
                                        </li>
                                        <br></br>
                                        <li><strong>mode</strong>
                                            <ul>
                                                <li><strong>light:</strong>
                                                    <ul>
                                                        <li>De esta forma se respeta el color especificado, el modo dark, es un tema oscuro que busca hacer más agradable el widget visualmente según la sensibilidad visual del usuario.</li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <br></br>
                                        <li><strong>iconPosition</strong>
                                            <ul>
                                                <li><strong>bottomRight:</strong>
                                                    <ul>
                                                        <li><strong>Visibilidad sin obstruir el contenido principal.</strong>
                                                            <ul>
                                                                <li>Normalmente, no interfiere con el contenido principal de la página, de esta forma no se obstaculiza la navegación del usuario y garantiza que el contenido sea accesible.</li>
                                                            </ul>
                                                        </li>
                                                        <li><strong>Patrón familiar para los usuarios.</strong>
                                                            <ul>
                                                                <li>Muchos sitios web y aplicaciones colocan iconos de chat, ayuda o accesibilidad en la esquina inferior derecha, por lo que los usuarios suelen buscar aquí estas herramientas.</li>
                                                            </ul>
                                                        </li>
                                                        <li><strong>Fácil acceso en dispositivos móviles.</strong>
                                                            <ul>
                                                                <li>Al estar en el extremo inferior derecho, es accesible para usuarios que navegan en móviles, ya que se encuentra cerca del área de acción del pulgar, lo que facilita su activación sin complicaciones.</li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <br></br>
                                        <li><strong>autoDeploy</strong>
                                            <ul>
                                                <li><strong>false:</strong>
                                                    <ul>
                                                        <li>Dejad que sea el usuario quien elija si desea acceder a las herramientas del widget o no, de lo contrario puede volverse molesto para ciertos usuarios.</li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <br></br>
                                        <li><strong>windowPosition</strong>
                                            <ul>
                                                <li><strong>right:</strong>
                                                    <ul>
                                                        <li><strong>Visibilidad sin obstruir el contenido principal.</strong>
                                                            <ul>
                                                                <li>Normalmente, no va a interferir con el contenido principal de la página, de esta forma no se obstaculiza la navegación del usuario y garantiza que el contenido del widget sea accesible.</li>
                                                            </ul>
                                                        </li>
                                                        <li><strong>Patrón familiar para los usuarios.</strong>
                                                            <ul>
                                                                <li>Cuando un usuario visualiza el botón del widget en un lateral, espera que el menú se muestre en dicho lateral.</li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <br></br>
                                        <li><strong>iconType</strong>
                                            <ul>
                                                <li>Aquí, recomendamos elegir el que más guste personalmente, ya que cualquiera de las 6 elecciones, son iconos universales que cumplen con la AAA de contraste de color y que se relacionan al instante con un widget de accesibilidad.</li>
                                            </ul>
                                        </li>
                                        <br></br>
                                        <li><strong>defaultLanguage</strong>
                                            <ul>
                                                <li>Idioma de la mayoría de usuarios que accedan a la web, o para los cuales esté orientado el contenido de la web.</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </Box>
                            </Box>
                        </Box>


                    </Box>

                    {/* Contacto */}
                    <Box ml={2.5}>
                        <Typography variant="body1" sx={{ marginTop: 10 }}>
                            <strong>Puede contactarnos</strong> mediante cualquiera de las vías que se ofrecen a continuación, contestaremos con la mayor brevedad posible.
                        </Typography>
                        <List sx={{ paddingLeft: 2 }}>
                            <ListItem disablePadding>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <FiberManualRecordIcon sx={{ fontSize: 10, color: "#0F52BD" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <span>
                                            Email: <Link href="mailto:hola@bemyvega.com">hola@bemyvega.com</Link>
                                        </span>
                                    }
                                />
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemIcon sx={{ minWidth: 20 }}>
                                    <FiberManualRecordIcon sx={{ fontSize: 10, color: "#0F52BD" }} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={
                                        <span>
                                            Web: <Link href="https://www.goviewser.com/contacto" target="_blank" rel="noopener">www.goviewser.com/contacto</Link>
                                        </span>
                                    }
                                />
                            </ListItem>
                        </List>
                        <Typography variant="body1">
                            <strong>Muchas gracias por confiar en nosotros</strong>, estaremos encantados de solucionar cualquier duda que le surja durante el proceso de implementación.
                        </Typography>
                    </Box>

                </Box>
            </Box>
        </Box>
    );
};

export default GuiaHtmlCss;